import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://verifaeye.com.au';

export const Seo = ({ title, description, path = '/', noindex = false }) => {
  const url = `${BASE_URL}${path}`;

  // Single-page navigations are not page loads, so Google Analytics needs telling
  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: path,
        page_location: window.location.href,
        page_title: title,
      });
    }
  }, [path, title]);

  useEffect(() => {
    // Remove build-time prerendered meta tags once React/Helmet takes over (avoids duplicates)
    document.querySelectorAll('[data-prerender]').forEach((el) => el.remove());
  }, []);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};
